//TODO: Put this back in '../plugins/validate',
var currMeshSelected;
var currMeshSelectedPrice;

var calcLength = function (form) {
  var lengthForm = $(form);
  //if the calculator contains a price mod
  if (lengthForm.find(".price-mod").length !== 0) {
    var selectElem = lengthForm.find(".price-mod"),
      pricePerFoot = selectElem.find("option:selected").data("price");
    lengthForm.find("input[name=price]").val(pricePerFoot);
  }
  var productLength = lengthForm.find("input[name=Length]").val();
  var pricePerFt = lengthForm.find("input[name=price]").val();
  var finalPricePerFt = pricePerFt * productLength;
  lengthForm
    .find("input[name=Product-Length]")
    .val(productLength + "ft." + "{p:" + finalPricePerFt + "}");
};

var reCalcSfPrice = function (form) {
  var submittedForm = $(form);
  var pricePerSqFt = submittedForm.find("input[name=price]").val();
  pricePerSqFt = parseFloat(pricePerSqFt);
  var netLength = submittedForm.find("input[name=Length]").val();
  var netWidth = submittedForm.find("input[name=Width]").val();
  var netSqFt = netLength * netWidth;
  netSqFt = parseFloat(netSqFt);
  var borderAddition = 0;
  //if the array of this find is greater than 0
  //basically, if it has a border option
  if (submittedForm.find(".border-option").length > 0) {
    var borderOptionSelected = $(".border-option")
      .find("option:selected")
      .val();
    borderOptionSelected = borderOptionSelected.substr(0, 5);
    // think this is leftover from old sports nets and no longer used
    // TODO: verify this claim
    if (borderOptionSelected == "Rope " || borderOptionSelected == "Webbi") {
      pricePerSqFt += 1;
    }
  }

  var finalPrice = (netSqFt * pricePerSqFt + borderAddition).toFixed(2);
  console.log("final:", finalPrice);
  if (submittedForm.hasClass("min-price")) {
    var minPrice = submittedForm.data("min-price");
    console.log(minPrice);
    if (finalPrice < minPrice) {
      var setupFee = minPrice - finalPrice;
      submittedForm
        .find("input[name=Square-Feet]")
        .val(netSqFt + "{p:" + minPrice + "}");
      submittedForm
        .find("input[name=Setup-Fee]")
        .val("$" + setupFee.toFixed(2));
    } else {
      submittedForm
        .find("input[name=Square-Feet]")
        .val(netSqFt + "{p:" + finalPrice + "}");
    }
  } else {
    submittedForm
      .find("input[name=Square-Feet]")
      .val(netSqFt + "{p:" + finalPrice + "}");
  }
  submittedForm.find("[data-product-calculated-price]").text("$" + finalPrice);
};

// for fall safety
var reCalcSfFSPrice = function (form) {
  var submittedForm = $(form);
  var pricePerSqFt = 0;
  var netLength = submittedForm.find("input[name=Length]").val();
  var netWidth = submittedForm.find("input[name=Width]").val();
  var netSqFt = netLength * netWidth;
  netSqFt = parseFloat(netSqFt);
  var selectedRadioVal = submittedForm.find("input[type=radio]:checked").val();

  if (netSqFt >= 301) {
    if (selectedRadioVal == "No Liner") {
      pricePerSqFt = 4.5;
    } else {
      pricePerSqFt = 5.4;
    }
  } else if (netSqFt <= 300) {
    if (selectedRadioVal == "No Liner") {
      pricePerSqFt = 5.5;
    } else {
      pricePerSqFt = 6.4;
    }
  }
  submittedForm
    .find("input[name=Square-Feet]")
    .val(
      netSqFt +
        "{p:" +
        netSqFt * pricePerSqFt +
        (selectedRadioVal == "With Debris Liner" ? "|c+-DL" : "") +
        "}"
    );
};

var validate = function (form) {
  return true;
};

// First drop down select
$(".price-mod").on("change", function () {
  var dropdown = $(this);
  currMeshSelected = dropdown.find("option:selected");
  currMeshSelectedPrice = currMeshSelected.data("price");
  currMeshSelectedPrice = parseFloat(currMeshSelectedPrice);
  dropdown.parents("form").find("input[name=price]").val(currMeshSelectedPrice);
  if ($(this).parent("form").attr("class") == "calc-sq-ft") {
    reCalcSfPrice(dropdown.parents("form"));
  }
});

$(".border-mod").on("change", function () {
  var dropdown = $(this);
  var form = dropdown.parents("form");
  currMeshSelected = dropdown.find("option:selected")[0];

  if (currMeshSelected.value === "Rope Bordered Panel") {
    var currMeshSelectedPrice = form
      .find(".border-pricing option:selected")
      .data("border-price");
  } else {
    var currMeshSelectedPrice = form
      .find(".border-pricing option:selected")
      .data("price");
  }
  currMeshSelectedPrice = parseFloat(currMeshSelectedPrice);
  form.find("input[name=price]").val(currMeshSelectedPrice);
});

$(".border-pricing").on("change", function () {
  var dropdown = $(this);
  var form = dropdown.parents("form");
  var modSelect = form.find($(".border-mod"))[0];
  currMeshSelected = $(modSelect).find("option:selected")[0];
  if (currMeshSelected.value === "Rope Bordered Panel") {
    var currMeshSelectedPrice = form
      .find(".border-pricing option:selected")
      .data("border-price");
  } else {
    var currMeshSelectedPrice = form
      .find(".border-pricing option:selected")
      .data("price");
  }
  currMeshSelectedPrice = parseFloat(currMeshSelectedPrice);
  form.find("input[name=price]").val(currMeshSelectedPrice);
});

$(".border-option").on("change", function () {
  reCalcSfPrice($(this).parents("form"));
});
$(".shade-cloth-dimensions").on("change", function () {
  reCalcSfPrice($(this).parents("form"));
});
//Detect if they change a border Option

//Square Footage Calculator
$(".calc-sq-ft")
  .each(function () {
    $(this).validate();
  })
  .on("submit", function () {
    if ($(this).attr("id") == "custom-fall-safety") {
      reCalcSfFSPrice(this);
    } else {
      reCalcSfPrice(this);
    }
  });

//Validate First Then
$(".calc-l-ft")
  .each(function () {
    $(this).validate();
  })
  .on("submit", function () {
    calcLength(this);
  });
$(".calc-debris").each(function () {
  $(this).validate();
});
$(".calc-debris select").on("change", function () {
  var form = $(this).closest("form");
  var widthSelected = parseFloat(
    form.find("select[name=Width] option:selected").data("width")
  );
  var lengthSelected = parseFloat(
    form.find("select[name=Length] option:selected").data("length")
  );
  var ppsq = parseFloat(form.find("input[name=price]").val());
  var price = widthSelected * lengthSelected * ppsq;
  var color = form.find("select[name=Color] option:selected").val();
  var sqFtInputString =
    lengthSelected * widthSelected +
    "{p:" +
    price +
    "|c+" +
    widthSelected +
    "" +
    lengthSelected;
  if (color) {
    sqFtInputString += "-" + color.substr(0, 1);
  }
  sqFtInputString += "}";
  form.find("input[name=Square-Feet]").val(sqFtInputString);
});

$(".calc-radio-opt input[type=radio]").on("change", function (e) {
  console.log($(this)[0].id);
  var form = $(this).closest("form");
  var colors = form.find("#Color");
  var newOptions;
  if ($(this)[0].id === "optionsRadios2") {
    //retardant
    newOptions =
      '<option value="">Select an Option</option><option value="Black">Black</option><option value="White">White</option><option value="Green">Green</option>';
  } else if ($(this)[0].id === "FireRetardant1") {
    //non-retardant
    newOptions =
      '<option value="">Select an Option</option><option value="Black">Black</option><option value="White">White</option>';
  }
  colors.html(newOptions);
  var sqFtPrice = $(e.target).data("sqft-price");
  console.log(sqFtPrice);
  if (parseFloat(sqFtPrice) > 0) {
    $(e.target).closest("form").find("input[name=price]").val(sqFtPrice);
  }
});

//export these super cool functions so other niggas can use it too
exports.calcLength = calcLength;
exports.reCalcSfPrice = reCalcSfPrice;



// WEBPACK FOOTER //
// ./utils/calculator.js